import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';
import '../../styles/money.css';

// Phone: choose the cards and save the sheet — the printing itself happens at a
// computer, but it can be prepared anywhere.
export default function LabelsMobile({ vm }) {
  const {
    canView, loading, functions, cards, chosen, picked, toggle, allOn, toggleAll,
    fnFilter, setFnFilter, typeFilter, setTypeFilter, q, setQ,
    withExtras, setWithExtras, startAt, setStartAt,
    stickers, slots, sheets, busy, savePdf,
  } = vm;

  if (!canView) {
    return (
      <div>
        <div className="page-head"><h1>Print labels</h1></div>
        <div className="card card-pad empty">You do not have access to the guests of this event.</div>
      </div>
    );
  }

  const on = (key) => !picked || picked.includes(key);

  return (
    <div className="mn-lbl-m">
      <div className="page-head">
        <h1>Print labels</h1>
        <span className="muted">{stickers} · {sheets} {sheets === 1 ? 'sheet' : 'sheets'}</span>
      </div>

      <div className="mn-filter2">
        <select value={fnFilter} onChange={e => setFnFilter(e.target.value)}>
          <option value="">All functions</option>
          {functions.map(f => <option key={f.FunctionId} value={f.FunctionId}>{f.FunctionName}</option>)}
        </select>
        <select value={typeFilter} onChange={e => setTypeFilter(e.target.value)}>
          <option value="">Families and firms</option>
          <option value="Family">Families only</option>
          <option value="Business">Firms only</option>
        </select>
      </div>
      <input type="search" className="mn-search-m" placeholder="Search…" value={q} onChange={e => setQ(e.target.value)}
        style={{ margin: '8px 0' }} />

      <div className="lbl-options">
        <label className="lbl-check">
          <input type="checkbox" checked={withExtras} onChange={e => setWithExtras(e.target.checked)} />
          Extra cards too
        </label>
        <label className="field lbl-num">Start at #
          <input type="number" inputMode="numeric" min="1" max={slots || 1} value={startAt}
            onChange={e => setStartAt(Math.max(1, Math.min(Number(e.target.value) || 1, slots || 1)))} />
        </label>
        <button type="button" className="linklike" onClick={toggleAll}>{allOn ? 'untick all' : 'tick all'}</button>
      </div>

      {loading ? <Spinner /> : (
        <div className="lbl-card-list">
          {cards.map(c => (
            <label key={c.key} className={'lbl-card-row' + (on(c.key) ? ' on' : '')}>
              <input type="checkbox" checked={on(c.key)} onChange={() => toggle(c.key)} />
              <span>
                <strong>{c.name}</strong>
                <span className="muted">{c.city ? ` · ${c.city}` : ''}{c.extraCards > 0 ? ` · +${c.extraCards}` : ''}</span>
              </span>
            </label>
          ))}
        </div>
      )}

      <div className="mn-actions-m">
        <button className="btn primary" data-save="primary"
          disabled={!!busy || !chosen.length} onClick={savePdf}>↓ Save the label sheet{chosen.length ? ` · ${stickers}` : ''}</button>
        <Link className="btn light" to="/app/label-setup">⚙ Label setup</Link>
      </div>
    </div>
  );
}
